import {ContentEditableHtmlEditorPlugin, EmbedProps} from '@frontapp/editor-html';
import {ReactNode} from 'react';

/** Adds React embed over scheduling link markup. */
export function createSchedulingLinkPlugin(
  renderEmbed: (domNode: Element, embedProps: EmbedProps) => ReactNode,
): ContentEditableHtmlEditorPlugin {
  return {
    processEmbeds: (element) => [],
    // Disable embed behavior for Fronteer launch of scheduling.
    // _(element.querySelectorAll('div[data-front-scheduling-link-id]'))
    //   .map(domNode => {
    //     if (!domNode.hasAttribute('style'))
    //       domNode.setAttribute('style', schedulingContainerStyle);

    //     if (!findSchedulingLinkIdFromElement(domNode))
    //       return null;

    //     return {
    //       domNode,
    //       renderEmbed
    //     };
    //   })
    //   .compact()
    //   .value()
  };
}

export function findSchedulingLinkIdFromElement(element: Element) {
  return Number(element.getAttribute('data-front-scheduling-link-id') || '');
}
